<template>
    <div id="reward_campaign_section">
        <div id="reward_search_lbl"
            :class="[{'color-mass': theme == 'mass'}, {'color-prestige': theme == 'prestige'}]">
            {{lbl.reward.search_result}}{{compSearchTxt}}
        </div>
        <div id="reward_campaign_list"
            v-if="isLoaded && isHaveItem">
            <RewardCampaignItem
                v-for="(campaign, i) in list"
                :key="i"
                :campaign="campaign" />
        </div>
        <div id="reward_no_campaign"
            v-if="isLoaded && !isHaveItem">
            <div class="icon-nodata">
                <img src="../../../../assets/icon/mass/ic-gift@2x.png" v-show="theme == 'mass'">
                <img src="../../../../assets/icon/prestige/ic-gift@2x.png" v-show="theme == 'prestige'">
            </div>
            <div class="text-nodata"
                :class="[{'color-mass': theme == 'mass'}, {'color-prestige': theme == 'prestige'}]">
                {{lbl.reward.no_data}}
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
// helper
import Account from '@/helper/AccountHelper.js';
// mixin
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
// component
import RewardCampaignItem from '../Campaign/RewardCampaignItem.vue';
// service
import { CampaignListConfigBuilder } from '@/core/Campaign/model/CampaignConfigModel.js';
import RewardService from '@/core/Custom/service/RewardService';
export default {
    name: 'SearchList',
    mixins: [ErrorApiMixin],
    components: {
        RewardCampaignItem
    },
    props: {
        lbl: { type: Object },
        searchTxt: { type: String },
        modalController: { type: Object }
    },
    computed: {
        isHaveItem: function () {
            return this.list.length > 0;
        },
        isAmbassador: function () {
            return this.$store.state.isAmbassador;
        },
        theme: function () {
            return this.$store.state.theme;
        }
    },
    data: function () {
        return {
            // page
            isLoading: false,
            // list
            compSearchTxt: this.searchTxt,
            list: [],
            listConfig: new CampaignListConfigBuilder(),
            isHaveMore: true,
            isLoaded: false
        };
    },
    watch: {
        searchTxt: function (newVal) {
            this.compSearchTxt = newVal;
        }
    },
    created: function () {
        console.log('props', this.searchTxt);
        console.log('data', this.compSearchTxt);
        let listConfig;
        if (this.isAmbassador) {
            listConfig = this.theme == 'mass' ? Vue.bzbsConfig.campaignConfig.mass_am : Vue.bzbsConfig.campaignConfig.prestige_am;
        } else {
            listConfig = this.theme == 'mass' ? Vue.bzbsConfig.campaignConfig.mass : Vue.bzbsConfig.campaignConfig.prestige;
        }

        this.listConfig.setConfigList(listConfig);
    },
    mounted: function () {
        this.initLoadMore();
    },
    methods: {
        search: function () {
            this.list = [];
            this.listConfig
                .setSearch(this.compSearchTxt)
                .setSkip(0);

            this.showLoading();
            this.getList();
        },
        getList: function () {
            const token = Account.getToken();
            const listConfig = this.listConfig.create();
            RewardService.apiGetCampaign(token, listConfig)
                .then(res => {
                    this.hideLoading();
                    this.listConfig.addSkip();

                    for (let campaign of res) {
                        this.list.push(campaign);
                    }

                    this.isLoaded = true;
                }).catch(err => {
                    this.hideLoading();
                    this.isLoaded = true;
                    this.list = [];
                    this.errorApi(err, this.errorHandler);
                });
        },
        initLoadMore: function () {
            window.onscroll = () => {
                var scrollOffSet = 100;
                var pageHeight = Math.max(
                    window.pageYOffset,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                var bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;
                if (bottomOfWindow) {
                    if (!this.isHaveMore) return;
                    if (this.showLoading()) return;

                    this.getList();
                }
            };
        },
        // loading
        showLoading: function () {
            if (this.isLoading) return true;

            this.isLoading = true;
            this.modalController.loadingModal.show();

            return false;
        },
        hideLoading: function () {
            this.isLoading = false;
            this.modalController.loadingModal.hide();
        },
    },
    beforeDestroy: function () {
        window.onscroll = null;
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
#reward_campaign_section {
    padding: {
        top: 25px;
        left: 18px;
        right: 18px;
        bottom: 25px;
    };

    #reward_search_lbl {
        // font-family: $heading;
        margin-bottom: 15px;

        &.color-mass{
            color: $mass_detail_font_color;
        }
        &.color-prestige{
            color: $prestige_theme_color;
        }
    }

    #reward_no_campaign{
        text-align: center;

        .icon-nodata{
            margin: {
                top: 120px;
                bottom: 15px;
            };
            img{
                width: 50px;
            }
        }
        .text-nodata{
            &.color-mass{
                color: $mass_detail_font_color;
            }
            &.color-prestige{
                color: $prestige_gold_color;
            }
        }
}
}
</style>